import {
  collection,
  getDocs,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";

import { db } from "../config/firebase";

const COLLECTIONS_PROPOSTAS = [
  "financeiro_propostas_os",
  "financeiro_propostas_preventivas",
  "financeiro_propostas_instalacoes",
];

export async function marcarPropostasFinalizadasPorSessao(sessaoId) {
  if (!sessaoId) return 0;

  let totalAtualizadas = 0;

  await Promise.all(
    COLLECTIONS_PROPOSTAS.map(async (collectionName) => {
      try {
        const snap = await getDocs(
          query(collection(db, collectionName), where("sessaoId", "==", sessaoId))
        );

        if (snap.empty) return;

        await Promise.all(
          snap.docs.map(async (docSnap) => {
            const data = docSnap.data() || {};
            const statusAtual = String(data?.status || "").toUpperCase();
            if (statusAtual === "FINALIZADA") return;

            await updateDoc(docSnap.ref, {
              status: "FINALIZADA",
              updatedAt: serverTimestamp(),
            });

            totalAtualizadas += 1;
          })
        );
      } catch (e) {
        console.warn(`Falha ao atualizar status em ${collectionName}:`, e);
      }
    })
  );

  return totalAtualizadas;
}
